<div class="webplayer sport-set">
  <img src="/assets/images/web-player-icon.svg" alt="GoArmy Edge Web Player">
  <a class="theplayer playerButton {{ selectedSport }}"
    (click)="selectWebPlayer()"
    angulartics2On="click"
    angularticsCategory="Launch Webplayer"
    angularticsEvent="Launch Webplayer"
    [angularticsProperties]="{ label: isFootball ? 'Football' : 'Soccer' }">
  </a>
  <a class="gear" (click)="selectGear()"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16"><path fill="#FFF" d="M6 0L5.6 2C4.8 2.3 4.1 2.7 3.4 3.3L1.6 2.5 0 5.1 1.5 6.5C1.4 7 1.3 7.5 1.3 8 1.3 8.5 1.4 9 1.5 9.5L0 10.9 1.6 13.5 3.4 12.7C4.1 13.3 4.8 13.7 5.6 14L6 16 9 16 9.4 14C10.2 13.7 10.9 13.3 11.6 12.7L13.4 13.5 15 10.9 13.5 9.5C13.6 9 13.7 8.5 13.7 8 13.7 7.5 13.6 7 13.5 6.5L15 5.1 13.4 2.5 11.6 3.3C10.9 2.7 10.2 2.3 9.4 2L9 0 6 0 6 0ZM7.5 4.6C9.4 4.6 10.9 6.1 10.9 8 10.9 9.9 9.4 11.4 7.5 11.4 5.6 11.4 4.1 9.9 4.1 8 4.1 6.1 5.6 4.6 7.5 4.6Z"/></svg></a>
</div>

<div class="dropdown">
  <h5>Choose Your Sport</h5>
  <a
    angulartics2On="click"
    angularticsCategory="Launch Webplayer"
    angularticsEvent="Launch Webplayer"
    [angularticsProperties]="{ label: 'Football' }"
    [class.active]="isFootball"
    (click)="setWebPlayer('football')"
    class="football playerButton">Football <img src="/assets/images/icon-football.svg" alt="Football Icon"></a>
  <a
    angulartics2On="click"
    angularticsCategory="Launch Webplayer"
    angularticsEvent="Launch Webplayer"
    [angularticsProperties]="{ label: 'Soccer' }"
    [class.active]="isSoccer"
    (click)="setWebPlayer('soccer')"
    class="soccer playerButton">Soccer <img src="/assets/images/icon-soccer.svg" alt="Soccer Icon"></a>
</div>
